import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Button from 'Components/UI/Button';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import CircularProgress from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/CircularProgress';

const styles = theme => ({
  root: {},
  hasActionButton: {
    paddingRight: theme.spacing(5),
  },
  buttonLoader: {
    color: theme.palette.common.white,
  },
});

const RunAnalysisButton = ({
  className,
  classes,
  onClick,
  hasActionButton,
  isLoading,
}) => {
  return (
    <Button
      className={classNames(classes.root, className, {
        [classes.hasActionButton]: hasActionButton,
      })}
      onClick={onClick}
      variant={'contained'}
      size={'medium'}
      color={'primary'}
      startIcon={isLoading
        ? (<CircularProgress
          className={classes.buttonLoader}
          size={20}
        />) : <PlayCircleFilledIcon />}
      round
      disableElevation
      test={'run-analysis-button'}
    >
      {'Check Roadmap'}
    </Button>
  );
};

RunAnalysisButton.defaultProps = {
  className: '',
  hasActionButton: false,
  isLoading: false,
};

RunAnalysisButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  hasActionButton: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default withStyles(styles)(RunAnalysisButton);
